import { Typography } from '@mui/material'
import React, { useState } from 'react'
import { styled } from '@mui/material/styles'

import CloseIcon from '@mui/icons-material/Close'
import Drawer from '@mui/material/Drawer'
import { Button, Input, Checkbox } from '@evocolabs/orkaui'

import { NextSeo } from 'next-seo'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Close24 from '@evocolabs/icons/lib/Close24'
import styles from './scss/Foundersletter.module.scss'
import Header from '@/src/components/HeaderV2'
import { useBackend } from '@/src/providers/BackendProvider'
import Forum from '@/src/components/Community/Forum'
import Footer from '@/src/components/Footer/Footer2'
const PREFIX = 'Foundersletter'

const classes = {
  cross: `${PREFIX}-cross`,
  reviewWrapper: `${PREFIX}-reviewWrapper`,
  thankWrapper: `${PREFIX}-thankWrapper`,
  titleWrapper: `${PREFIX}-titleWrapper`,
  storyWrapper: `${PREFIX}-storyWrapper`,
  infoWrapper: `${PREFIX}-infoWrapper`,
  title: `${PREFIX}-title`,
  subTitle: `${PREFIX}-subTitle`,
  storyTitle: `${PREFIX}-storyTitle`,
  input: `${PREFIX}-input`,
  inputStory: `${PREFIX}-inputStory`,
  buttonWrapper: `${PREFIX}-buttonWrapper`,
  button: `${PREFIX}-button`,
  thankTitle: `${PREFIX}-thankTitle`,
  readerImg: `${PREFIX}-readerImg`,
  shareWrapper: `${PREFIX}-shareWrapper`,
  shareInside: `${PREFIX}-shareInside`,
  shareButtonText: `${PREFIX}-shareButtonText`,
  shareWelcomeText: `${PREFIX}-shareWelcomeText`,
  Button: `${PREFIX}-Button`
}

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.cross}`]: {
    cursor: 'pointer',
    position: 'absolute',
    right: '5vw',
    top: '5vh',
    [theme.breakpoints.down('md')]: {
      top: '36px',
      right: '8vw'
    }
  },

  [`& .${classes.reviewWrapper}`]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // marginTop: '5vh',
    margin: 'auto',
    maxWidth: '776px',
    marginBottom: '5vh',
    padding: '5vw',
    [theme.breakpoints.down('md')]: {
      marginTop: '40px'
    }
  },

  [`& .${classes.thankWrapper}`]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
    maxWidth: '776px',
    marginTop: '20vh'
  },

  [`& .${classes.titleWrapper}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '24px',
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    width: '100%'
  },

  [`& .${classes.storyWrapper}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '32px 24px',
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    marginTop: '24px',
    width: '100%',
    gap: '8px'
  },

  [`& .${classes.infoWrapper}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '32px 24px',
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    marginTop: '24px',
    width: '100%',
    gap: '8px'
  },

  [`& .${classes.title}`]: {
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '33px',
    letterSpacing: '-0.4px'
  },

  [`& .${classes.subTitle}`]: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '29px',
    letterSpacing: '-0.2px',
    marginTop: '8px'
  },

  [`& .${classes.storyTitle}`]: {
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '27px',
    letterSpacing: '-0.5px'
  },

  [`& .${classes.input}`]: {
    width: '100%'
  },

  [`& .${classes.inputStory}`]: {
    width: '100%',
    height: '190px'
  },

  [`& .${classes.buttonWrapper}`]: {
    marginTop: '24px'
  },

  [`& .${classes.button}`]: {
    padding: '12px 56px'
  },

  [`& .${classes.thankTitle}`]: {
    fontWeight: 600,
    fontSize: '30.97px',
    lineHeight: '42.59px',
    letterSpacing: '-0.52px'
  },

  [`& .${classes.readerImg}`]: {
    marginTop: '42px'
  },

  [`& .${classes.shareWrapper}`]: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    backgroundColor: '#FCFCFD',
    // marginBottom: '124px',
    paddingBottom: '128px',
    marginTop: '-64px',
    [theme.breakpoints.down('md')]: {
      backgroundColor: '#ffffff',
      padding: '8vh 5vw'
    }
  },

  [`& .${classes.shareInside}`]: {
    display: 'flex',
    flexDirection: 'row',
    maxWidth: '1024px',
    width: '100%',
    margin: 'auto',
    height: '85px',
    backgroundColor: '#F1F1F1',
    justifyContent: 'center',
    borderRadius: '8px',
    alignItems: 'center',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      padding: '24px 16px'
    }
  },

  [`& .${classes.shareButtonText}`]: {
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '14.4px',
    color: '#ffffff'
  },

  [`& .${classes.shareWelcomeText}`]: {
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '27px',
    letterSpacing: '-0.5px',
    color: '#1A1A1A',
    wordBreak: 'break-word',
    textAlign: 'center',
    marginRight: '24px',
    [theme.breakpoints.down('sm')]: {
      width: '50%',
      textAlign: 'left'
    }
  },

  [`& .${classes.Button}`]: {
    width: '193px',
    marginTop: '40px',
    padding: '12px 14.5px'
  }
}))

const checkLabel =
  'Upon submitting your review, you consent to having it showcased on the Orka website for others to see.'

let closeDrawerTimerId = null
const EndPage = ({ setOpenDrawer, setPage, open }) => {
  const handleClickClose = () => {
    setOpenDrawer(false)
  }
  clearTimeout(closeDrawerTimerId)
  if (open) {
    closeDrawerTimerId = setTimeout(function () {
      setOpenDrawer(false)
      setTimeout(() => setPage('story'), 100)
    }, 2500)
  }
  return (
    <div style={{ padding: '10vw' }}>
      <CloseIcon onClick={handleClickClose} className={classes.cross} />
      <div className={classes.thankWrapper}>
        <div>
          <Typography className={classes.thankTitle}>Thanks for your sharing!</Typography>
        </div>
      </div>
    </div>
  )
}

const ShareStoryButton = () => {
  const [open, setOpen] = useState(false)
  const [page, setPage] = useState('story')
  const handleClickOpen = () => {
    setOpen(true)
  }
  return (
    <Root className={classes.shareWrapper}>
      <div className={classes.shareInside}>
        <Typography className={classes.shareWelcomeText}>New stories are welcomed.</Typography>
        <Button handleClick={handleClickOpen} id="reviews-page-share-story-button">
          <Typography className={classes.shareButtonText}>Share Now</Typography>
        </Button>
        <Drawer
          open={open}
          anchor="bottom"
          variant="temporary"
          style={{
            zIndex: '2000',
            backgroundColor: '#EEEDE9',
            position: 'absolute'
          }}
          PaperProps={{
            style: {
              minHeight: '100%',
              backgroundColor: '#EEEDE9',
              zIndex: 9999
            }
          }}
        >
          {page === 'story' && <StoryPage setOpenDrawer={setOpen} setPage={setPage} />}
          {page === 'end' && <EndPage setOpenDrawer={setOpen} open={open} setPage={setPage} />}
        </Drawer>
      </div>
    </Root>
  )
}

const StoryPage = ({ setOpenDrawer, setPage }) => {
  const { postStory, messageBoardSubscribe } = useBackend()
  const [title, setTitle] = useState('')
  const [story, setStory] = useState('')
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [aggree, setAggree] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [error, setError] = useState({
    title: '',
    story: '',
    name: '',
    email: ''
  })

  const handleClickClose = () => {
    setOpenDrawer(false)
  }

  const handleChangeTitle = (event) => {
    setTitle(event.target.value)
    if (event.target.value === '') {
      setError({ ...error, title: 'Please fill out your title' })
    } else {
      setError({ ...error, title: '' })
    }
  }

  const handleChangeStory = (event) => {
    setStory(event.target.value)
    if (event.target.value === '') {
      setError({ ...error, story: 'Please fill out your story' })
    } else {
      setError({ ...error, story: '' })
    }
  }

  const handleChangeEmail = (event) => {
    setEmail(event.target.value)
    if (event.target.value === '') {
      setError({ ...error, email: 'Please fill out your email' })
    } else {
      setError({ ...error, email: '' })
    }
  }

  const handleChangeName = (event) => {
    setName(event.target.value)
    if (event.target.value === '') {
      setError({ ...error, name: 'Please fill out your name' })
    } else {
      setError({ ...error, name: '' })
    }
  }

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  }

  const checkInfo = () => {
    return title !== '' && story !== '' && name !== '' && email !== '' && validateEmail(email)
  }

  const setMissingError = () => {
    const currentError = { ...error }
    if (title === '') {
      currentError.title = 'Please fill out your title'
      // setError({ ...error, title: 'Please fill out the title' })
    }
    if (story === '') {
      currentError.story = 'Please fill out your story'
      // setError({ ...error, story: 'Please fill out the story' })
    }
    if (name === '') {
      currentError.name = 'Please fill out your name'
      // setError({ ...error, name: 'Please fill out the name' })
    }
    if (email === '') {
      currentError.email = 'Please fill out your email'
      // setError({ ...error, email: 'Please fill out the email' })
    } else if (!validateEmail(email)) {
      currentError.email = 'Invalid email address'
    }
    setError(currentError)
  }

  const handleSubmit = async () => {
    if (checkInfo()) {
      if (!aggree && !openDialog) {
        setOpenDialog(true)
        return
      }
      const details = { name: name, story: story, title: title, email: email }
      await postStory(details)
      await messageBoardSubscribe(details)
      setPage('end')
    } else {
      setMissingError()
      // window.alert('Please fill out all information')
    }
  }
  const handleConfirmAndSubmit = () => {
    setOpenDialog(false)
    setAggree(true)
    document.querySelector('#storySubmit').click()
  }
  return (
    <Root>
      <CloseIcon onClick={handleClickClose} className={classes.cross} />
      <div className={classes.reviewWrapper}>
        <div className={styles['border-yellow']} />
        <div className={classes.titleWrapper}>
          <Typography className={classes.title}>Share your story with us</Typography>
          <Typography className={classes.subTitle}>
            Orka is dedicated to make healthcare more human-centered via tech innovation. Whether an experience hearing
            aid user or a new user, tell us your experience with hearing. Leave your story and become one of the
            earliest users for Orka's latest models!
          </Typography>
        </div>
        <div className={classes.storyWrapper}>
          <Typography className={classes.storyTitle}>What is your story?</Typography>
          <Input
            id="review-title"
            placeholder="Title of your story"
            type="title"
            value={title}
            onChange={handleChangeTitle}
            required
            controlProps={classes.input}
            errorMsg={error.title}
            fullWidth
          />
          <Input
            id="review-story"
            placeholder="Your story here"
            type="story"
            value={story}
            onChange={handleChangeStory}
            required
            inputProps={classes.inputStory}
            controlProps={classes.input}
            multiline
            errorMsg={error.story}
            fullWidth
          />
        </div>
        <div className={classes.infoWrapper}>
          <Typography className={classes.storyTitle}>About you</Typography>
          <Input
            id="review-name"
            placeholder="Name"
            inputProps={{ maxLength: 50 }}
            type="Name"
            value={name}
            onChange={handleChangeName}
            required
            controlProps={classes.input}
            errorMsg={error.name}
            fullWidth
          />
          <Input
            id="review-email"
            placeholder="Email"
            type="Email"
            value={email}
            inputProps={{ maxLength: 50 }}
            onChange={handleChangeEmail}
            required
            controlProps={classes.input}
            errorMsg={error.email}
            fullWidth
          />
        </div>
        <Checkbox
          checked={aggree}
          onChange={() => {
            setAggree(!aggree)
          }}
          controlSx={{ gap: '8px', mt: '16px' }}
          label={checkLabel}
        />
        <div className={classes.buttonWrapper}>
          <Button
            className={classes.button}
            id="reviews-page-share-story-submit-button"
            size="large"
            loadable
            handleClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
        <Dialog
          id="dialogPop"
          open={openDialog}
          onClose={() => {
            setOpenDialog(false)
          }}
          sx={{ zIndex: '9999' }}
          PaperProps={{
            sx: {
              borderRadius: '12px',
              minWidth: '35%',
              maxWidth: '500px',
              textAlign: 'center',
              padding: { xs: '16px', sm: '32px' }
            }
          }}
        >
          <div
            onClick={() => setOpenDialog(false)}
            style={{
              position: 'absolute',
              right: '24px',
              top: '24px',
              cursor: 'pointer'
            }}
          >
            <Close24 />
          </div>
          <DialogTitle>
            <Typography sx={{ textAlign: 'center' }} variant="h3">
              Please Acknowledge the Following:
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1" textAlign="center">
              I consent to showcasing my review on the Orka Website for others to view.
            </Typography>
            <Button
              handleClick={handleConfirmAndSubmit}
              sx={{ mt: '32px' }}
              size="large"
              id="reviews-page-share-story-confirm-button"
            >
              Confirm and Submit
            </Button>
          </DialogContent>
        </Dialog>
      </div>
    </Root>
  )
}

export async function getServerSideProps() {
  const url = process.env.NEXT_PUBLIC_BASEURL + 'forum/'
  const res = await fetch(url)
  const data = await res.json()
  return { props: { data } }
}

function UserReviews({ data }) {
  return (
    <>
      <NextSeo
        title="Reviews | Orka Customer Reviews"
        description="Hear from Orka's happy customers. Every user's opinion matters."
      />
      <Header isWhiteBg />
      <Root style={{ position: 'relative', backgroundColor: '#E5E5E5' }}>
        <div id="restPage" style={{ position: 'relative' }}>
          <div style={{ width: '100%', backgroundColor: '#FCFCFD' }}>
            <Forum data={data} />
          </div>
          <ShareStoryButton />
          <div style={{ backgroundColor: '#fafafa' }}>
            <Footer />
          </div>
        </div>
      </Root>
    </>
  )
}

export default UserReviews
